let imgSrc = require('./imgSrc');
let level = {
  normal: 'normal',
  mild: 'mild',
  severe: 'severe'
};
let bodyPart = {
  faceNormal:true,
  sideNormal:true,
  backNormal:true,
}
let pains = {
  back: {
    head: ['rake', 'fore'],
    shoulder: ['shoulder','round'],
    trunk: ['spine'],
    'lower extremity': ['legX', 'legO', 'legStretch', 'legXO']
  },
  face:{
    shoulder:['round'],
    trunk:['trunk'],
    'lower extremity': ['legForX', 'legForO', 'legForStretch']
  },
  side:{
    head: ['fore'],
    shoulder: ['shoulder','round'],
  }
};

let init_t= {
  descripName: {},
  boneDescription: {},
  details: {},
}
function init(dName,bDescription,details) {
  init_t.descripName = dName;
  init_t.boneDescription = bDescription;
  init_t.details = details;
}

function descripName(des) {
  console.log('init_t:descripName:',init_t.descripName);
  if(des === 'weak'){
    return {name: ' '+init_t.descripName.upName, color:'rgb(179,173,143)' }
  }else if(des === 'tension'){
    return {name:' '+init_t.descripName.lowName,color:'rgb(255,138,128)' }
  }
}
function getShoulderLeftOrRight(direction) {
  if(direction.length > 0){
    return direction
  }else{
    return false
  }
  console.log('|||||||:', init_t.details);
  console.log({
    detail:key
  })
  // switch (key) {
  //
  //   // case init_t.details.lh:
  //   //   return 'left';
  //   // case init_t.details.ll:
  //   //   return 'left';
  //   // case init_t.details.rh:
  //   //   return 'right';
  //   // case init_t.details.rr:
  //   //   return 'right';
  //   // default:
  //   //   return false
  //   case '左高':
  //     return 'left';
  //   case '左倾':
  //     return 'left';
  //   case '右高':
  //     return 'right';
  //   case '右倾':
  //     return 'right';
  //   default:
  //     return false
  // }
}
let boneDescription = {
  face : {
    trunk:'腹部肌群',
    legForX:['髋外旋肌','髋内收肌'],
    legForO:'髋外旋肌',
    legForStretch:'股四头肌',
    round:'胸大肌'
  },
  side:{
    round:'胸锁乳突肌',
    fore:'胸锁乳突肌',
    shoulder:'斜角肌'
  },
  back:{
    spine:'高侧斜方肌',
    shoulder:'高侧斜方肌',
    round:['高侧斜方肌','低侧斜方肌'],
    fore:['高侧斜方肌','低侧斜方肌'],
    rake:'肩胛提肌',
    legStretch:['腘绳肌','足底筋膜'],
    legX:['髋外旋肌','股二头肌'],
    legO:['半腱肌半膜肌','足内翻肌群'],
    legXO:['股二头肌','足底筋膜']
  }
};

let faceRad,backRad,
  faceWidth,backWidth,sideWidth,
  faceHeight,sideHeight,backHeight;


  //正面数据
function drawFrontBone(data, canvas) {
  //canvas画笔
  let faceCanvas = canvas;
  let windowWidth = document.documentElement.clientWidth > 1025 ? document.documentElement.clientWidth/2: document.documentElement.clientWidth

 /*  if(windowWidth < 376){
    windowWidth= windowWidth+10;
  }else if((windowWidth >= 376 ) && ( windowWidth <700) ){
    //console.log('test',windowWidth)

  }else if((windowWidth >= 700 ) && ( windowWidth <1500) ){
    windowWidth = windowWidth/2
  }else{
    windowWidth= windowWidth/4*0.8;
  } */
  ////console.log("windowWidth",windowWidth)
  let windowHeight = window.screen.height
  faceCanvas.width = windowWidth * 1.7;
  faceWidth = faceCanvas.width;
  faceHeight = faceCanvas.height;
  let faceBodyPostion= {
    imgUrl:imgSrc.bone.boneCanvas,
    sx:100,
    sy:50,
    swidth:420,
    sheight:900,
    x:faceWidth/3*0.8,
    y:-24,
    width:420,
    height:900

  };
  //取对应的点
  let facePoints = data.conclusion.face.points;
  let faceRisks = data.conclusion.face.risks;

  let bodyDirection = getBodyDirection('face',faceRisks);
  //////console.log('faceBodyDirection =>', bodyDirection);

  let hipRPoint = facePoints['hip']['right']
  let hipLPoint = facePoints['hip']['left']
  let hipMPoint = {
    x: 0,
    y: 0
  }
  if ((hipLPoint.x === 0 && hipLPoint.y === 0) || (hipRPoint.x === 0 && hipRPoint.y === 0)) {

  } else {
    // 计算左右骨盆连线中点
    hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2
    hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2
  };

  //部位角度
  faceRad = {
    //头部
    // head: getRad(facePoints.ear.right, facePoints.ear.left, true),
    head: getRad(facePoints.nose, hipMPoint),
    //肩膀
    shoulder: getRad(facePoints.shoulder.right, facePoints.shoulder.left, true),
    // 胳膊
    shoulderToElbowL: getRad(facePoints.shoulder.right, facePoints.elbow.right)-0.5,
    shoulderToElbowR: getRad(facePoints.shoulder.left, facePoints.elbow.left)+0.5,
    //手臂
    elbowToWristL: getRad(facePoints.elbow.right, facePoints.wrist.right)-0.5,
    elbowToWristR:getRad(facePoints.elbow.left, facePoints.wrist.left)+ 0.5,
    //骨盆
    hip: getRad(facePoints.hip.right, facePoints.hip.left, true),
    //大腿
    hipToKneeL: getRad(facePoints.hip.right, facePoints.knee.right),
    hipToKneeR: getRad(facePoints.hip.left, facePoints.knee.left),
    //小腿
    kneeToAnkleL: getRad(facePoints.knee.right, facePoints.ankle.right),
    kneeToAnkleR:  getRad(facePoints.knee.left, facePoints.ankle.left),
  };
  //具体描绘的参数
  let locationInfo = {
    head: {
      key: 'head',
      type: 'normal',
      x: 0,
      y: 0,
      width: 94,
      height: 152,
      offsetW: faceWidth / 2-40,
      offsetH: -20,
      translateX:0,
      //translateX: faceWidth / 2,
      translateY:0,
      //translateY: 152,
      rotate:0,
      //rotate: faceRad.head,
      afterTranslate:false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over',
    },
    body: {
      key: 'body',
      type: 'normal',
      //x: bodyDirection.position=== 'shoulder' ? bodyDirection.lOrR === 'left' ? 1120 : 1400 : bodyDirection.position === 'pelvis' ?  bodyDirection.lOrR === 'left' ? 560 : 840 : 280,
      x: 556,
      y: 0,
      width: 230,
      height: 330,
      offsetW:faceWidth/2-111,
      offsetH:82,
      translateX:0,
      //translateX: 0,
      translateY:0,
      //translateY: 0,
      rotate:0,
      //rotate: 0,
      afterTranslate:false,
      //afterTranslate:false,
    },
    trunk: {
      key: 'trunk',
      type: 'pain',
      x: 560,
      y: 800,
      width: 94,
      height: 200,
      offsetW: faceWidth/2-36,
      offsetH: 202,
      translateX:0,
      //translateX: 0,
      translateY:0,
      //translateY: 0 ,
      rotate:0,
      //rotate: 0,
      afterTranslate:false,
      //afterTranslate:false,
      descriptionX:faceWidth-182,
      descriptionY:240,
      descriptionWidth:180,
      descriptionHeight:40,
      description:'weak',
      lineX:faceWidth-182+10/4,
      lineY:240+40-10/4,
      moveX:faceWidth/2+5,
      moveY:265,
      globalCompositeOperation: 'source-over'
    },
    thigh: {
      left: {
        key: 'thigh-left',
        type: 'normal',
        x: 280,
        y: 400,
        width: 94,
        height: 250,
        offsetW: faceWidth/2+5,
        offsetH: 322,
        translateX:0,
        //translateX:faceWidth/2+75,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'thigh-right',
        type: 'normal',
        x: 0,
        y: 400,
        width: 100,
        height: 250,
        offsetW: faceWidth/2-89,
        offsetH: 322,
        translateX:0,
        //translateX:faceWidth/2-59,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    legForO: {
      right: {
        key: 'legForO-right',
        type: 'pain',
        x: 0,
        y: 800,
        width: 100,
        height: 100,
        offsetW: faceWidth/2-79,
        offsetH: 326,
        translateX:0,
        //translateX:faceWidth/2-59,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:0,
        // descriptionY:400,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:180-10/4,
        // lineY:400+10/4,
        // moveX:faceRad.hipToKneeL>0?faceWidth/2-111+30-10+2-position(faceRad.hipToKneeL,'x',50)+25 : faceWidth/2-111+30-10+2+position(faceRad.hipToKneeL,'x',50)+25,
        // moveY:152-70+330-80-10+position(faceRad.hipToKneeL,'y',50),
        globalCompositeOperation: 'source-over'
      },
      left: {
        key: 'legForO-left',
        type: 'pain',
        x: 280,
        y: 800,
        width: 100,
        height: 100,
        offsetW: faceWidth/2+50,
        offsetH: 326,
        translateX:0,
        //translateX:faceWidth/2+35,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:faceWidth-182,
        descriptionY:450,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'tension',
        lineX:faceWidth-182+10/4,
        lineY:450+10/4,
        moveX:faceWidth/2+position(faceRad.hipToKneeR,'x',50)+70,
        moveY:322+position(faceRad.hipToKneeR,'y',50),
        globalCompositeOperation: 'source-over'
      },
    },
    legForX: {
      right1: {
        key: 'legForX-right1',
        type: 'pain',
        x: 840,
        y: 800,
        width: 100,
        height: 100,
        offsetW: faceWidth/2-78,
        offsetH: 326,
        translateX:0,
        //translateX:faceWidth/2-59,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:0,
        // descriptionY:400,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:180-10/4,
        // lineY:400+10/4,
        // moveX:faceRad.hipToKneeL>0?faceWidth/2-111+30-10+2-position(faceRad.hipToKneeL,'x',50)+25 : faceWidth/2-111+30-10+2+position(faceRad.hipToKneeL,'x',50)+25,
        // moveY:152-70+330-80-10+position(faceRad.hipToKneeL,'y',50),
        globalCompositeOperation: 'source-over'
      },
      right2: {
        key: 'legForX-right2',
        type: 'pain',
        x: 1400,
        y: 800,
        width: 200,
        height: 200,
        offsetW: faceWidth/2-37,
        offsetH: 342,
        translateX:0,
        //translateX:faceWidth/2-59,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:1,
        descriptionY:160,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'tension',
        lineX:178.5,
        lineY:197.5,
        moveX:faceWidth/2+position(faceRad.hipToKneeL,'x',50)-15,
        moveY:342+position(faceRad.hipToKneeL,'y',100),
        globalCompositeOperation: 'source-over'
      },
      left1: {
        key: 'legForX-left1',
        type: 'pain',
        x: 1120,
        y: 800,
        width: 100,
        height: 100,
        offsetW: faceWidth/2+51,
        offsetH: 326,
        translateX:0,
        //translateX:faceWidth/2+35,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:faceWidth-182,
        descriptionY:450,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'weak',
        lineX:faceWidth-179.5,
        lineY:452.5,
        moveX:faceWidth/2+position(faceRad.hipToKneeR,'x',50)+70,
        moveY:322+position(faceRad.hipToKneeR,'y',50),
        globalCompositeOperation: 'source-over'
      },
      left2: {
        key: 'legForX-left2',
        type: 'pain',
        x: 1680,
        y: 800,
        width: 200,
        height: 200,
        offsetW: faceWidth/2+9,
        offsetH: 342,
        translateX:0,
        //translateX:faceWidth/2+35,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:faceWidth-180-2,
        // descriptionY:470,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:faceWidth-180+10/4-2,
        // lineY:470+10/4,
        // moveX:faceWidth/2-111+111+5+position(faceRad.hipToKneeR,'x',60)+20,
        // moveY:152-70+330-90+position(faceRad.hipToKneeR,'y',120),
        globalCompositeOperation: 'source-over'
      },
    },
    legForStretch:{
      left:{
        key: 'legForStretch-left',
        type: 'pain',
        x: 2240,
        y: 800,
        width: 200,
        height: 200,
        offsetW: faceWidth/2+41,
        offsetH: 350,
        translateX:0,
        //translateX:faceWidth/2+35,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:faceWidth-220-2,
        // descriptionY:540,
        // descriptionWidth:220,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:faceWidth-220+10/4-2,
        // lineY:540+10/4,
        // moveX:faceWidth/2-111+111+5+position(faceRad.hipToKneeR,'x',60)+50,
        // moveY:152-70+330-90+position(faceRad.hipToKneeR,'y',120),
        globalCompositeOperation: 'source-over'
      },
      right:{
        key: 'legForStretch-right',
        type: 'pain',
        x: 1960,
        y: 800,
        width: 200,
        height: 200,
        offsetW: faceWidth/2-80,
        offsetH: 346,
        translateX:0,
        //translateX:faceWidth/2-59,
        translateY:0,
        //translateY:382,
        rotate:0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:1,
        descriptionY:500,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'weak',
        lineX:178.5,
        lineY:502.5,
        moveX:faceWidth/2+position(faceRad.hipToKneeL,'x',60)-50,
        moveY:position(faceRad.hipToKneeL,'y',120)+324,
        globalCompositeOperation: 'source-over'
      }
    },
    shank: {
      left: {
        key: 'shank-left',
        type: 'normal',
        x: 560,
        y: 400,
        width: 58,
        height: 250,
        offsetW: faceWidth/2+position(faceRad.hipToKneeL,'x',190)-84,
        offsetH: 322+position(faceRad.hipToKneeL,'y',190),
        translateX:0,
        //translateX:faceWidth/2-81,
        translateY:0,
        //translateY:382,
        rotateBefore:false,
        //rotateBefore: true,
        //translateXBefore: faceWidth/2+position(faceRad.hipToKneeL,'x',190)-16,
        //translateYBefore: position(faceRad.hipToKneeL,'y',190)+347,//
        rotateBeforeRad:0,
        //rotateBeforeRad:faceRad.kneeToAnkleL,
        rotate:0,
        //rotate: faceRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'shank-right',
        type: 'normal',
        x: 840,
        y: 400,
        width: 58,
        height: 250,
        offsetW:faceWidth/2+position(faceRad.hipToKneeR,'x',190)+30,
        offsetH: 322+position(faceRad.hipToKneeR,'y',190),
        translateX:0,
        //translateX:faceWidth/2+75,
        translateY:0,
        //translateY:392,
        rotateBefore:false,
        //rotateBefore: true,
        //translateXBefore:faceWidth/2+position(faceRad.hipToKneeR,'x',190)+45,
        //translateYBefore:position(faceRad.hipToKneeR,'y',190)+352,//
        rotateBeforeRad:0,
        //rotateBeforeRad:faceRad.kneeToAnkleR,
        rotate:0,
        //rotate: faceRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
    },
    foot: {
      left: {
        key: 'foot-left',
        type: 'normal',
        x: 1400,
        y: 400,
        width: 68,
        height: 68,
        offsetW:faceWidth/2+position(faceRad.hipToKneeR,'x',190)+45,
        offsetH: position(faceRad.hipToKneeR,'y',190)+502,
        translateX:0,
        //translateX:faceWidth/2+position(faceRad.hipToKneeR,'x',190)+45,
        translateY:0,
        //translateY:position(faceRad.hipToKneeR,'y',190)+352,
        rotate:0,
        //rotate: faceRad.kneeToAnkleR,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'foot-right',
        type: 'normal',
        x: 1120,
        y: 400,
        width: 68,
        height: 68,
        offsetW: faceWidth/2-109+position(faceRad.hipToKneeL,'x',190),
        offsetH: 502+position(faceRad.hipToKneeL,'y',190),
        translateX:0,
        //translateX: faceWidth/2-16+position(faceRad.hipToKneeL,'x',190),
        translateY:0,
        //translateY:347+position(faceRad.hipToKneeL,'y',190),
        rotate:0,
        //rotate: faceRad.kneeToAnkleL,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
    },
    upperArm: {
      left: {
        key: 'upperArm-left',
        type: 'normal',
        x: 1679,
        y: -20,
        width: 120,
        height: 160,
        offsetW: faceWidth/2-152 ,
        offsetH: 116,
        translateX:0,
        //translateX:faceWidth/2-90,
        translateY:0,
        //translateY:141,
        rotate:0,
        //rotate:faceRad.shoulderToElbowL,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'upperArm-right',
        type: 'normal',
        x: 1960,
        y: 0,
        width: 120,
        height: 160,
        offsetW:faceWidth/2+83,
        offsetH: 113,
        translateX:0,
        //translateX:faceWidth/2+84,
        translateY:0,
        //translateY: 141,
        rotate:-10*Math.PI/180,
        //rotate: faceRad.shoulderToElbowR,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    foreArm: {
      left: {
        key: 'foreArm-left',
        type: 'normal',
        x: 2234,
        y: -8,
        width: 150,
        height: 190,
        offsetW:faceWidth/2-147+position(faceRad.shoulderToElbowL+0.5,'x',120)-60,
        offsetH: 100+position(faceRad.shoulderToElbowL+0.5,'y',120),
        translateX:0,
        //translateX:faceWidth/2-80,
        translateY:0,
        //translateY:141,
        rotateBefore:false,
        //rotateBefore: true,
        //translateXBefore:faceWidth/2-85+position(faceRad.shoulderToElbowL+0.5,'x',120),
        //translateYBefore:position(faceRad.shoulderToElbowL+0.5,'y', 120) + 150,//
        rotateBeforeRad:0,
        //rotateBeforeRad:faceRad.elbowToWristL,
        rotate:0,
        //rotate:faceRad.shoulderToElbowL,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'foreArm-right',
        type: 'normal',
        x: 2520,
        y: 0,
        width: 150,
        height: 190,
        offsetW: faceWidth/2+113+position(faceRad.shoulderToElbowR-0.5,'x',120),
        offsetH: 100+position(faceRad.shoulderToElbowR-0.5,'y',120),
        translateX:0,
        //translateX:faceWidth/2+84,
        translateY:0,
        //translateY: 141,
        rotateBefore:false,
        //rotateBefore: true,
        //translateXBefore:faceWidth/2+82+position(faceRad.shoulderToElbowR-0.5,'x',120),
        //translateYBefore: 141+position(faceRad.shoulderToElbowR-0.5,'y',120),//
        rotateBeforeRad:0,
        //rotateBeforeRad:faceRad.elbowToWristR,
        rotate:0,
        //rotate: faceRad.shoulderToElbowR,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    round: {
      left: {
        key: 'round-left',
        type: 'pain',
        x: 1680,
        y: 400,
        width: 100,
        height: 100,
        offsetW: faceWidth/2-70,
        offsetH: 125,
        translateX:0,
        //translateX:0,
        translateY:0,
        //translateY:0,
        rotate:0,
        //rotate: 0,
        // descriptionX:0,
        // descriptionY:400,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:180-10/4,
        // lineY:400+10/4,
        // moveX:faceRad.hipToKneeL>0?faceWidth/2-111+30-10+2-position(faceRad.hipToKneeL,'x',50)+25 : faceWidth/2-111+30-10+2+position(faceRad.hipToKneeL,'x',50)+25,
        // moveY:152-70+330-80-10+position(faceRad.hipToKneeL,'y',50),
        globalCompositeOperation: 'source-over'
      },
      right: {
        key: 'round-right',
        type: 'pain',
        x: 1960,
        y: 400,
        width: 100,
        height: 100,
        offsetW: faceWidth/2+5,
        offsetH: 125,
        translateX:0,
        //translateX:0,
        translateY:0,
        //translateY:0,
        rotate:0,
        //rotate: 0,
        descriptionX:faceWidth-150-2,
        descriptionY:80,
        descriptionWidth:150,
        descriptionHeight:40,
        description:'weak',
        lineX:faceWidth-150-2+2.5,
        lineY:80+40-2.5,
        moveX:faceWidth/2+50,
        moveY:160,
        globalCompositeOperation: 'source-over'
      },
    },
  }
  //描绘部位顺序
  let faceOrder = [
    'head',
    'body',
    'foot-right',
    'thigh-left',
    'thigh-right',
    'shank-right',
    'upperArm-right',
    'foreArm-right',
    'upperArm-left',
    'foreArm-left',
    'shank-left',
    'foot-left',
    'foot-right',
    'legForStretch-left',
    'legForStretch-right',
    'legForO-right',
    'legForO-left',
    'legForX-left1',
    'legForX-left2',
    'legForX-right1',
    'legForX-right2',
    'trunk',
    'round-left',
    'round-right',
  ]

  let facePain = getPainArr('face', data.conclusion,pains);
  ////console.log('facePain->',facePain);
  // 按身体部位绘制顺序取出每个部位的具体信息
  let faceOrderInfos = getOrderInfos(locationInfo, faceOrder);
  //开始绘制
  let faceImg = new Image();
  faceImg.src = imgSrc.bone.faceBone;

  let faceBodyImg = new Image();
  faceBodyImg.src = faceBodyPostion.imgUrl;

  faceImg.onload = function () {
    let ctx = faceCanvas.getContext('2d');
    //console.log("img w:",faceImg.width," img H:",faceImg.height,'faceWidth:',faceWidth,faceBodyImg.width)
    faceBodyPostion.sx = 0;
    faceBodyPostion.sy = 0;
    faceBodyPostion.x = (document.documentElement.clientWidth-1290*0.34/3)/2-27;
    faceBodyPostion.y = -50;
    faceBodyPostion.width =1219*0.34;
    faceBodyPostion.height =913*0.9;
    drawBone('face',ctx,faceOrderInfos,facePain,faceImg,0,(windowHeight-89)*220/faceHeight,faceBodyPostion)
  }
}
//侧面数据
function drawSideBone(data, canvas) {
  let sideCanvas = canvas;
  let windowWidth = document.documentElement.clientWidth > 1025 ? document.documentElement.clientWidth/2: document.documentElement.clientWidth


  let windowHeight = window.screen.height
  sideCanvas.width = windowWidth * 1.7;
  sideWidth = sideCanvas.width;
  sideHeight = sideCanvas.height;


  if(document.documentElement.clientWidth >= 1500){
    windowWidth= windowWidth/2*1.1-5;
  }

  let sideBody = document.documentElement.clientWidth;

  if(sideBody < 700){
    sideBody= sideBody/2*0.9-10;
  }else if((sideBody >= 700 ) && ( sideBody <1500) ){
    sideBody = sideBody*0.6+33
  }else{
    sideBody= sideBody/3+20;
  }
  let sideBodyPostion= {
    imgUrl:imgSrc.bone.boneCanvas,
    sx:400,
    sy:50,
    swidth:380,
    sheight:800,
    //x:sideWidth/3*0.8,
    x:sideBody,
    y:-20,
    width:380,
    height:800

  };


  let sideRisks = data.conclusion.side.risks;
  let sidePoints = data.conclusion.side.points;
  let sideDirection = data.conclusion.side.side;
  let bodyDirection = getBodyDirection('side',sideRisks);
  ////console.log('sideBodyDirection->',sidePoints['shoulder'][sideDirection], sidePoints['elbow'][sideDirection])
  let sideRad = {
    earToShoulder: getRad(sidePoints['ear'][sideDirection], sidePoints['shoulder'][sideDirection]),
    shoulderToElbow: getRad(sidePoints['shoulder'][sideDirection], sidePoints['elbow'][sideDirection])+0.1,
    elbowToWrist: getRad(sidePoints['elbow'][sideDirection], sidePoints['wrist'][sideDirection])+0.2,
    hipToKnee: getRad(sidePoints['hip'][sideDirection], sidePoints['knee'][sideDirection]),
    kneeToAnkle: getRad(sidePoints['knee'][sideDirection], sidePoints['ankle'][sideDirection]),
  };
  ////console.log('sideRad.shoulderToElbow',sideRad.shoulderToElbow)
  let sideLocationInfo = {
    head: {
      key: 'head',
      type: 'normal',
      x: 0,
      y: 0,
      width: 114,
      height: 156,
      offsetW: sideWidth/2,
      offsetH: 0,
      translateX:0,
      //translateX: sideWidth/2+57,
      translateY:0,
      //translateY: 156,
      rotate:0,
      //rotate: sideRad.earToShoulder,
      afterTranslate:false,
      //afterTranslate:true,
    },
    body: {
      key: 'body',
      type: 'normal',
      x: bodyDirection.position === 'round' ? 560 : 280 ,
      y: 0,
      width: 200,
      height: 300,
      offsetW: bodyDirection.position === 'round' ? sideWidth/2 - 40 : sideWidth/2 - 10,
      offsetH: 106,
      translateX:0,
      //translateX: 0,
      translateY:0,
      //translateY: 0,
      rotate:0,
      //rotate: 0,
      afterTranslate:false,
      //afterTranslate:false,
    },
    shank:{
      key: 'shank',
      type: 'normal',
      x: 1400,
      y: 0,
      width: 100,
      height: 270,
      offsetW: sideWidth/2,
      offsetH: 306,
      translateX:0,
      //translateX: sideWidth/2+50,
      translateY:0,
      //translateY: 346,
      rotate:0,
      //rotate: sideRad.hipToKnee,
      afterTranslate:false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over',
    },
    thigh:{
      key: 'thigh',
      type: 'normal',
      x: 1680,
      y: 0,
      width: 140,
      height: 270,
      offsetW: sideWidth/2+position(sideRad.hipToKnee,'x',230),
      offsetH: 306+position(sideRad.hipToKnee,'y',230),
      translateX:0,
      //translateX: sideWidth/2+50,
      translateY:0,
      //translateY: 346,
      rotateBefore:false,
      //rotateBefore: true,
      //translateXBefore:sideWidth/2+position(sideRad.hipToKnee,'x',230)+50,
      //translateYBefore:336+position(sideRad.hipToKnee,'y',230),//
      rotateBeforeRad:0,
      //rotateBeforeRad:sideRad.kneeToAnkle,
      rotate:0,
      //rotate: sideRad.hipToKnee,
      afterTranslate:false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over'
    },
    upperArm:{
      key: 'upperArm',
      type: 'normal',
      x: 840,
      y: 0,
      width: 100,
      height: 200,
      offsetW: sideWidth / 2-20,
      offsetH: 150,
      translateX:0,
      //translateX: sideWidth / 2+40,
      translateY:0,
      //translateY: 165,
      rotate:0,
      //rotate: sideRad.shoulderToElbow,
      afterTranslate:false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over',
    },
    foreArm:{
      key: 'upperArm',
      type: 'normal',
      x: 1120,
      y: 0,
      width:100,
      height: 250,
      offsetW: sideWidth / 2+position(sideRad.shoulderToElbow,'x',110)-10,
      offsetH: 140+position(sideRad.shoulderToElbow,'y',110)-20,
      translateX:0,
      //translateX: sideWidth / 2+40,
      translateY:0,
      //translateY: 165,
      rotateBefore:false,
      //rotateBefore: true,
      //translateXBefore:sideWidth / 2+position(sideRad.shoulderToElbow,'x',110)+20,
      //translateYBefore:140+position(sideRad.shoulderToElbow,'y',110)+20,//
      rotateBeforeRad:0,
      //rotateBeforeRad:sideRad.elbowToWrist,
      rotate:0,
      //rotate: sideRad.shoulderToElbow,
      afterTranslate:false,
      //afterTranslate:true,
      globalCompositeOperation: 'source-over'
    },
    round:{
      key: 'round',
      type: 'pain',
      x: 0,
      y: 400,
      width: 50,
      height: 50,
      offsetW: sideWidth/2+20,
      offsetH: 80,
      translateX:0,
      //translateX: sideWidth/2+57,
      translateY:0,
      //translateY: 156,
      rotate:0,
      //rotate: sideRad.earToShoulder,
      afterTranslate:false,
      //afterTranslate:true,
      descriptionX:sideWidth-162,
      descriptionY:180,
      descriptionWidth:210,
      descriptionHeight:40,
      description:'tension',
      lineX:sideWidth-159.5,
      lineY:182.5,
      moveX:sideWidth/2+50-position(sideRad.earToShoulder,'x',60),
      moveY:130-position(sideRad.earToShoulder,'y',30),
      globalCompositeOperation: 'source-over',
    },
    fore:{
      key: 'fore',
      type: 'pain',
      x: 840,
      y: 400,
      width: 50,
      height: 50,
      offsetW: sideWidth/2+20,
      offsetH: 80,
      translateX:0,
      //translateX: sideWidth/2+57,
      translateY:0,
      //translateY: 156,
      rotate:0,
      //rotate: sideRad.earToShoulder,
      afterTranslate:false,
      //afterTranslate:true,
      descriptionX:sideWidth-162,
      descriptionY:180,
      descriptionWidth:210,
      descriptionHeight:40,
      description:'tension',
      lineX:sideWidth-159.5,
      lineY:182.5,
      moveX:sideWidth/2+50-position(sideRad.earToShoulder,'x',60),
      moveY:130-position(sideRad.earToShoulder,'y',30),
      globalCompositeOperation: 'source-over',
    },
    shoulder:{
      left:{
        key: 'shoulder-left',
        type: 'pain',
        x: 280,
        y: 400,
        width: 50,
        height: 50,
        offsetW: sideWidth/2+20,
        offsetH: 80,
        translateX:0,
        //translateX: sideWidth/2+57,
        translateY:0,
        //translateY: 156,
        rotate:0,
        //rotate: sideRad.earToShoulder,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:51,
        descriptionY:180,
        descriptionWidth:150,
        descriptionHeight:40,
        description:'weak',
        lineX:198.5,
        lineY:182.5,
        moveX:sideWidth/2+40-position(sideRad.earToShoulder,'x',60),
        moveY:140-position(sideRad.earToShoulder,'y',30),
        globalCompositeOperation: 'source-over',
      },
      right:{
        key: 'shoulder-right',
        type: 'pain',
        x: 560,
        y: 400,
        width: 50,
        height: 50,
        offsetW: sideWidth/2+20,
        offsetH: 80,
        translateX:0,
        //translateX: sideWidth/2+57,
        translateY:0,
        //translateY: 156,
        rotate:0,
        //rotate: sideRad.earToShoulder,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:51,
        descriptionY:180,
        descriptionWidth:150,
        descriptionHeight:40,
        description:'tension',
        lineX:198.5,
        lineY:182.5,
        moveX:sideWidth/2+40-position(sideRad.earToShoulder,'x',60),
        moveY:140-position(sideRad.earToShoulder,'y',30),
        globalCompositeOperation: 'source-over',
      }
    },
  };

  let sideOrder = [
    'head',
    'body',
    'shank',
    'thigh',
    'upperArm',
    'foreArm',
    'round',
    'fore',
    'shoulder-left',
    'shoulder-right',
  ];

  let sidePain = getPainArr('side', data.conclusion,pains);
  ////console.log('sidePain->',sidePain);

  let sideOrderInfos = getOrderInfos(sideLocationInfo, sideOrder);
  let sideImg = new Image();
  sideImg.src = imgSrc.bone.sideBone;


  sideImg.onload = function() {
    let ctx = sideCanvas.getContext('2d');
    drawBone('side',ctx,sideOrderInfos,sidePain,sideImg,-50,(windowHeight-89)*220/sideHeight,sideBodyPostion)
  }
}
//背面数据
function drawBackBone(data, canvas) {
  let backCanvas = canvas;
  let windowWidth = document.documentElement.clientWidth > 1025 ? document.documentElement.clientWidth/2: document.documentElement.clientWidth
  let windowHeight = window.screen.height

  backCanvas.width = windowWidth * 1.7;
  backWidth = backCanvas.width;
  backHeight = backCanvas.height;
  //取对应的点
  let backPoints = data.conclusion.face.points;
  let backRisks = data.conclusion.face.risks.concat(data.conclusion.side.risks);
  let bodyDirection = getBodyDirection('back',backRisks);
  //////console.log("backBodyDirection->",bodyDirection);
  let backBody = document.documentElement.clientWidth;

  if(backBody < 700){
    backBody= backBody/3*0.94
  }else if((backBody >= 700 ) && ( backBody <1500) ){
    backBody = backBody/2+65
  }else{
    backBody= backBody/3-25
  }
  let backBodyPostion= {
    imgUrl:imgSrc.bone.boneCanvas,
    sx:700,
    sy:50,
    swidth:500,
    sheight:800,
    x:sideWidth/3*0.8,
    //x:0,
    y:15,
    width:500,
    height:700

  };
  let hipRPoint = backPoints['hip']['right']
  let hipLPoint = backPoints['hip']['left']
  let hipMPoint = {
    x: 0,
    y: 0
  }
  if ((hipLPoint.x === 0 && hipLPoint.y === 0) || (hipRPoint.x === 0 && hipRPoint.y === 0)) {

  } else {
    // 计算左右骨盆连线中点
    hipMPoint.x = (hipLPoint.x + hipRPoint.x) / 2
    hipMPoint.y = (hipLPoint.y + hipRPoint.y) / 2
  };
  backRad = {
    //头部
    head: getRad(backPoints.nose, hipMPoint),
    // head: getRad(backPoints.ear.right, backPoints.ear.left, true),
    //肩膀
    shoulder: getRad(backPoints.shoulder.right, backPoints.shoulder.left, true),
    //胳膊
    shoulderToElbowL: getRad(backPoints.shoulder.right, backPoints.elbow.right)-0.5,
    shoulderToElbowR: getRad(backPoints.shoulder.left, backPoints.elbow.left)+0.5,
    //手臂
    elbowToWristL: getRad(backPoints.elbow.right, backPoints.wrist.right)-0.3,
    elbowToWristR: getRad(backPoints.elbow.left, backPoints.wrist.left)+0.3,
    //骨盆
    hip: getRad(backPoints.hip.right, backPoints.hip.left, true),
    // 大腿
    hipToKneeL: getRad(backPoints.hip.right, backPoints.knee.right),
    hipToKneeR: getRad(backPoints.hip.left, backPoints.knee.left),
    // 小腿
    kneeToAnkleL: getRad(backPoints.knee.right, backPoints.ankle.right),
    kneeToAnkleR: getRad(backPoints.knee.left, backPoints.ankle.left),
  };
  let thighLeftTranslateX = backWidth / 2,thighLeftTranslateY = 376;
  let thighRightTranslateX = backWidth/2+105,thighRightTranslateY = 376;
  let translateX = -35;
  let backLocationInfo = {
    head: {
      key: 'head',
      type: 'normal',
      x: 0,
      y: 0,
      width: 114,
      height: 140,
      offsetW: backWidth/2,
      offsetH: -10,
      translateX:0,
      //translateX: backWidth/2+57,
      translateY:0,
      //translateY: 156,
      rotate:0,
      //rotate: -backRad.head,
      afterTranslate:false,
      //afterTranslate:true,
    },
    body: {
      key: 'body',
      type: 'normal',
      x: bodyDirection.position === 'rake' ? 560 : bodyDirection.position === 'shoulder' ?bodyDirection.lOrR === 'left' ? 840 : 1120 :280,
      y: 0,
      width: 260,
      height: 380,
      offsetW: backWidth/2-65,
      offsetH: 86,
      translateX:0,
      //translateX: 0,
      translateY:0,
      //translateY: 0,
      rotate:0,
      //rotate: 0,
      afterTranslate:false,
      //afterTranslate:false,
    },
    shank:{
      left:{
        key: 'shank-left',
        type: 'normal',
        x: 2520,
        y: 0,
        width: 100,
        height: 260,
        offsetW: backWidth/2-50,
        offsetH: 336,
        translateX:0,
        //translateX: thighLeftTranslateX,
        translateY:0,
        //translateY: thighLeftTranslateY,
        rotateBefore:false,
        //rotateBefore: 0,
        rotate:0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over',
      },
      right:{
        key: 'shank-right',
        type: 'normal',
        x: 2800,
        y: 0,
        width: 100,
        height: 260,
        offsetW: backWidth/2+35,
        offsetH: 336,
        translateX:0,
        //translateX: thighRightTranslateX,
        translateY:0,
        //translateY: thighRightTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over',
      }
    },
    thigh:{
      left:{
        key: 'thigh-left',
        type: 'normal',
        x: 3080,
        y: 0,
        width: 100,
        height: 260,
        offsetW: backWidth/2-55+position(-backRad.hipToKneeR,'x',180),
        offsetH: 336+position(-backRad.hipToKneeR,'y',180),
        translateX:0,
        //translateX: thighLeftTranslateX,
        translateY:0,
        //translateY: thighLeftTranslateY,
        rotateBefore:false,
        //rotateBefore: true,
        //translateXBefore:backWidth/2-15+position(-backRad.hipToKneeR,'x',180),
        //translateYBefore:376+position(-backRad.hipToKneeR,'y',180),//
        rotateBeforeRad:0,
        //rotateBeforeRad:-backRad.kneeToAnkleR,
        rotate:0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right:{
        key: 'thigh-right',
        type: 'normal',
        x: 3360,
        y: 0,
        width: 100,
        height: 260,
        offsetW:backWidth/2+69+position(-backRad.hipToKneeL,'x',180),
        offsetH:336+position(-backRad.hipToKneeL,'y',180),
        translateX:0,
        //translateX: thighRightTranslateX,
        translateY:0,
        //translateY: thighRightTranslateY,
        rotateBefore:false,
        //rotateBefore: true,
        //translateXBefore:backWidth/2+104+position(-backRad.hipToKneeL,'x',180),
        //translateYBefore:376+position(-backRad.hipToKneeL,'y',180),//
        rotateBeforeRad:0,
        //rotateBeforeRad:-backRad.kneeToAnkleL,
        rotate:0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    upperArm:{
      left:{
        key: 'upperArm-left',
        type: 'normal',
        x: 1400,
        y: 0,
        width: 140,
        height: 180,
        offsetW: backWidth/2-120,
        offsetH: 130,
        translateX:0,
        //translateX: backWidth/2-40,
        translateY:0,
        //translateY: 180,
        rotate:0,
        //rotate: -backRad.shoulderToElbowR,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over',
      },
      right:{
        key: 'upperArm-right',
        type: 'normal',
        x: 1680,
        y: 0,
        width: 140,
        height: 260,
        offsetW: backWidth/2+110,
        offsetH: 135,
        translateX:0,
        //translateX: backWidth/2+130,
        translateY:0,
        //translateY: 185,
        rotate:0,
        //rotate:  -backRad.shoulderToElbowL,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over',
      }
    },
    foreArm:{
      left:{
        key: 'foreArm-left',
        type: 'normal',
        x: 1960,
        y: 0,
        width: 140,
        height: 260,
        offsetW: backWidth/2-185+position(-backRad.shoulderToElbowR+0.5,'x',140)+32,
        offsetH: 125+position(-backRad.shoulderToElbowR+0.5,'y',140),
        translateX:0,
        //translateX: backWidth/2-40,
        translateY:0,
        //translateY: 180,
        rotateBefore:false,
        //rotateBefore: true,
        //translateXBefore:backWidth/2-120+position(-backRad.shoulderToElbowR+0.5,'x',140)+20+70,
        //translateYBefore:130+position(-backRad.shoulderToElbowR+0.5,'y',140)+35,//
        rotateBeforeRad:0,
        //rotateBeforeRad: -backRad.elbowToWristR,
        rotate:0,
        //rotate:-backRad.shoulderToElbowR,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      },
      right:{
        key: 'foreArm-right',
        type: 'normal',
        x: 2240,
        y: 0,
        width: 140,
        height: 260,
        offsetW: backWidth/2+165+position(-backRad.shoulderToElbowL-0.5,'x',140)-10,
        offsetH: 135+position(-backRad.shoulderToElbowL-0.5,'y',140)-4,
        translateX:0,
        //translateX: backWidth/2+130,
        translateY:0,
        //translateY: 185,
        rotateBefore:false,
        //rotateBefore: true,
        //translateXBefore:backWidth/2+97+position(-backRad.shoulderToElbowL-0.5,'x',140)-10+35,
        //translateYBefore:135+position(-backRad.shoulderToElbowL-0.5,'y',140)-4+40,//
        //// translateXBefore:backWidth/2+122+position(-backRad.shoulderToElbowL-0.5,'x',140)+5,
        //// translateYBefore:175+position(-backRad.shoulderToElbowL-0.5,'y',140)-12,//
        rotateBeforeRad:0,
        //rotateBeforeRad:-backRad.elbowToWristL,
        rotate:0,
        //rotate: -backRad.shoulderToElbowL,
        afterTranslate:false,
        //afterTranslate:true,
        globalCompositeOperation: 'source-over'
      }
    },
    spine:{
      left1:{
        key: 'spine-left1',
        type: 'pain',
        x: 0,
        y: 400,
        width: 100,
        height: 100,
        offsetW: backWidth / 2-20,
        offsetH: 115,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        descriptionX:-translateX+1,
        descriptionY:220,
        descriptionWidth:210,
        descriptionHeight:40,
        description:'tension',
        lineX:208.5-translateX,
        lineY:222.5,
        moveX:backWidth/2+15,
        moveY:144,
        globalCompositeOperation: 'source-over',
      },
      left2:{
        key: 'spine-left2',
        type: 'pain',
        x: 280,
        y: 400,
        width: 100,
        height: 100,
        offsetW: backWidth / 2+55,
        offsetH: 114,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        /* descriptionX:backWidth-220+50-2,
         descriptionY:0,
         descriptionWidth:220,
         descriptionHeight:40,
         description:'weak',
         lineX:backWidth-220+50-2+10/4,
         lineY:40-10/4,
         moveX:370,
         moveY:140,*/
        globalCompositeOperation: 'source-over',
      },
      right1:{
        key: 'spine-right1',
        type: 'pain',
        x: 560,
        y: 400,
        width: 100,
        height: 100,
        offsetW: backWidth / 2-20,
        offsetH: 114,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        // descriptionX:50,
        // descriptionY:0,
        // descriptionWidth:220,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+220-10/4,
        // lineY:40-10/4,
        // moveX:320,
        // moveY:140,
        globalCompositeOperation: 'source-over',
      },
      right2:{
        key: 'spine-right2',
        type: 'pain',
        x: 840,
        y: 400,
        width: 100,
        height: 100,
        offsetW: backWidth / 2+55,
        offsetH: 114,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        descriptionX:backWidth-202-translateX,
        descriptionY:220,
        descriptionWidth:200,
        descriptionHeight:40,
        description:'tension',
        lineX:backWidth-199.5-translateX,
        lineY:222.5,
        moveX:backWidth/2+80,
        moveY:144,
        globalCompositeOperation: 'source-over',
      }
    },
    shoulder: {
      left1: {
        key: 'shoulder-left1',
        type: 'pain',
        x: 3360,
        y: 800,
        width: 100,
        height: 100,
        offsetW: backWidth / 2-20,
        offsetH: 116,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        descriptionX:-translateX+1,
        descriptionY:220,
        descriptionWidth:210,
        descriptionHeight:40,
        description:'tension',
        lineX:208.5-translateX,
        lineY:222.5,
        moveX:backWidth/2+15,
        moveY:140,
        globalCompositeOperation: 'source-over',
      },
      left2: {
        key: 'shoulder-left2',
        type: 'pain',
        /* x: 3640,
         y: 800,
         width: 100,
         height: 100,*/
        x: 3080,
        y: 790,
        width: 100,
        height: 100,
        offsetW: backWidth / 2+55,
        offsetH: 106,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        /*descriptionX:backWidth-200+50-2,
        descriptionY:220,
        descriptionWidth:220,
        descriptionHeight:40,
        description:'weak',
        lineX:backWidth-200+50-2+10/4,
        lineY:220+10/4,
        moveX:backWidth/2+90,
        moveY:140,*/
        globalCompositeOperation: 'source-over',
      },
      right1: {
        key: 'shoulder-right1',
        type: 'pain',
        x: 2800,
        y: 800,
        width: 100,
        height: 100,
        offsetW: backWidth / 2-20,
        offsetH: 106,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        // descriptionX:50,
        // descriptionY:0,
        // descriptionWidth:220,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+220-10/4,
        // lineY:40-10/4,
        // moveX:320,
        // moveY:140,
        globalCompositeOperation: 'source-over',
      },
      right2: {
        key: 'shoulder-right2',
        type: 'pain',
        x: 3080,
        y: 800,
        width: 100,
        height: 100,
        offsetW: backWidth / 2+50,
        offsetH: 116,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        descriptionX:backWidth-212-translateX,
        descriptionY:220,
        descriptionWidth:210,
        descriptionHeight:40,
        description:'tension',
        lineX:backWidth-209.5-translateX,
        lineY:222.5,
        moveX:backWidth/2+80,
        moveY:140,
        globalCompositeOperation: 'source-over',
      }
    },
    round:{
      left: {
        key: 'round-left',
        type: 'pain',
        x: 1120,
        y: 400,
        width: 100,
        height: 200,
        offsetW: backWidth / 2-20,
        offsetH: 116,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        descriptionX:-translateX+1,
        descriptionY:220,
        descriptionWidth:210,
        descriptionHeight:40,
        description:'weak',
        lineX:210-translateX-2.5,
        lineY:222.5,
        moveX:backWidth/2+30,
        moveY:200,
        globalCompositeOperation: 'source-over',
      },
      right: {
        key: 'round-right',
        type: 'pain',
        x: 1400,
        y: 400,
        width: 100,
        height: 200,
        offsetW: backWidth / 2+52,
        offsetH: 116,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        descriptionX:backWidth-210-2-translateX,
        descriptionY:220,
        descriptionWidth:210,
        descriptionHeight:40,
        description:'weak',
        lineX:backWidth-210-2-translateX+2.5,
        lineY:222.5,
        moveX:backWidth/2+80,
        moveY:140,
        globalCompositeOperation: 'source-over',
      }
    },
    fore:{
      left: {
        key: 'fore-left',
        type: 'pain',
        x: 2240,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2-20,
        offsetH: 111,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotate:0,
        //rotate: 0,
        descriptionX:-translateX+1,
        descriptionY:220,
        descriptionWidth:210,
        descriptionHeight:40,
        description:'weak',
        lineX:-translateX+1+210-2.5,
        lineY:222.5,
        moveX:backWidth/2+30,
        moveY:200,
        globalCompositeOperation: 'source-over',
      },
      right: {
        key: 'fore-right',
        type: 'pain',
        x: 2520,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2+50+5,
        offsetH: 111,
        translateX:0,
        //translateX: 0,
        translateY:0,
        //translateY: 0,
        rotateBefore:false,
        //rotateBefore: 0,
        rotate:0,
        //rotate: 0,
        maxRotate: 0,
        minRotate: 0,
        saveBefore: true,
        restoreAfter: true,
        descriptionX:backWidth-210-translateX-1,
        descriptionY:220,
        descriptionWidth:210,
        descriptionHeight:40,
        description:'tension',
        lineX:backWidth-210-translateX+2.5,
        lineY:222.5,
        moveX:backWidth/2+80,
        moveY:140,
        globalCompositeOperation: 'source-over',
      }
    },
    rake:{
      left1: {
        key: 'rake-left1',
        type: 'pain',
      /*  x: 1120,
        y: 800,
        width: 100,
        height: 200,*/
        x: 1680,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2+20,
        offsetH: 76,
        translateX: backWidth/2+57,
        translateY: 156,
        rotate: -backRad.head,
        afterTranslate:true,
       /* descriptionX:-translateX+2,
        descriptionY:40,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'tension',
        lineX:-translateX+2+180-2.5,
        lineY:77.5,
        moveX:backWidth/2+35-position(-backRad.head,'x',60),
        moveY:120-position(-backRad.head,'y',20),*/
        globalCompositeOperation: 'source-over',
      },
      left2: {
        key: 'rake-left2',
        type: 'pain',
        x: 1400,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2+50,
        offsetH: 76,
        translateX: backWidth/2+57,
        translateY: 156,
        rotate: -backRad.head,
        afterTranslate:true,
        descriptionX:backWidth-200-2+50,
        descriptionY:60,
        descriptionWidth:200,
        descriptionHeight:40,
        description:'weak',
        lineX:backWidth-200-2+50+10/4,
        lineY:60+40-10/4,
        moveX:backWidth/2+57-position(-backRad.head,'x',60),
        moveY:130-position(-backRad.head,'y',20),
        globalCompositeOperation: 'source-over',
      },
      right1: {
        key: 'rake-right1',
        type: 'pain',
        /*x: 1680,
        y: 800,
        width: 100,
        height: 200,*/
        x: 1120,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2+20,
        offsetH: 76,
        translateX: backWidth/2+57,
        translateY: 156,
        rotate: -backRad.head,
        afterTranslate:true,
        // descriptionX:50,
        // descriptionY:60,
        // descriptionWidth:160,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+160-10/4,
        // lineY:60+40-10/4,
        // moveX:backWidth/2+35-position(-backRad.head,'x',60),
        // moveY:130-position(-backRad.head,'y',20),
        globalCompositeOperation: 'source-over',
      },
      right2: {
        key: 'rake-right2',
        type: 'pain',
        x: 1960,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth / 2+50,
        offsetH: 76,
        translateX: backWidth/2+57,
        translateY: 156,
        rotate: -backRad.head,
        afterTranslate:true,
        descriptionX:backWidth-180-translateX-2,
        descriptionY:40,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'tension',
        lineX:backWidth-180-translateX-2+2.5,
        lineY:77.5,
        moveX:backWidth/2+57-position(-backRad.head,'x',60),
        moveY:120-position(-backRad.head,'y',20),
        globalCompositeOperation: 'source-over',
      }
    },
    legStretch:{
      left1:{
        key: 'legStretch-left1',
        type: 'pain',
        x: 0,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth/2-28,
        offsetH: 435,
        translateX:0,
        //translateX: thighLeftTranslateX,
        translateY:0,
        //translateY: thighLeftTranslateY,
        rotateBefore:false,
        //rotateBefore: 0,
        rotate:0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:50+1,
        // descriptionY:550,
        // descriptionWidth:200,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+200-10/4+1,
        // lineY:550+10/4,
        // moveX:backWidth/2-50+10+5+5+30+position(-backRad.hipToKneeR,'x',120),
        // moveY:100+380-110+100-30-5+position(-backRad.hipToKneeR,'y',60),
        globalCompositeOperation: 'source-over',
      },
      right1:{
        key: 'legStretch-right1',
        type: 'pain',
        x: 280,
        y: 800,
        width: 100,
        height: 200,
        offsetW: backWidth/2+73,
        offsetH: 435,
        translateX:0,
        //translateX: thighRightTranslateX,
        translateY:0,
        //translateY: thighRightTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:backWidth-150-translateX-2,
        descriptionY:550,
        descriptionWidth:150,
        descriptionHeight:40,
        description:'weak',
        lineX:backWidth-150-translateX-2+2.5,
        lineY:552.5,
        moveX:backWidth/2+95+position(-backRad.hipToKneeL,'x',120),
        moveY:430+position(-backRad.hipToKneeL,'y',60),
        globalCompositeOperation: 'source-over',
      },
      left2:{
        key: 'legStretch-left2',
        type: 'pain',
        x: 560,
        y: 800,
        width: 100,
        height: 100,
        offsetW: backWidth/2-42+position(-backRad.hipToKneeR,'x',180),
        offsetH: 578+position(-backRad.hipToKneeR,'y',180),
        translateX:0,
        //translateX: backWidth/2-15+position(-backRad.hipToKneeR,'x',180),
        translateY:0,
        //translateY: 376+position(-backRad.hipToKneeR,'y',180),
        rotate:0,
        //rotate: -backRad.kneeToAnkleR,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:-translateX+2,
        descriptionY:680,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'tension',
        lineX:-translateX+2+180-2.5,
        lineY:717.5,
        moveX:backWidth/2+position(-backRad.hipToKneeR,'x',180)+position(-backRad.kneeToAnkleR,'x',210)-18,
        moveY:373+position(-backRad.hipToKneeR,'y',180)+position(-backRad.kneeToAnkleR,'y',210),
        globalCompositeOperation: 'source-over'
      },
      right2:{
        key: 'legStretch-right2',
        type: 'pain',
        x: 840,
        y: 800,
        width: 100,
        height: 100,
        offsetW:backWidth/2+97+position(-backRad.hipToKneeL,'x',180),
        offsetH:578+position(-backRad.hipToKneeL,'y',180),
        translateX:0,
        //translateX: backWidth/2+104+position(-backRad.hipToKneeL,'x',180),
        translateY:0,
        //translateY: 376+position(-backRad.hipToKneeL,'y',180),
        rotate:0,
        //rotate: -backRad.kneeToAnkleL,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:backWidth-180-2+50,
        // descriptionY:680,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:backWidth-180-2+50+10/4,
        // lineY:680+40-10/4,
        // moveX:backWidth/2+30+5+position(-backRad.hipToKneeL,'x',180)+30+10+position(-backRad.kneeToAnkleL,'x',210)+30,
        // moveY:156-70+200+50+position(-backRad.hipToKneeL,'y',180)+40+position(-backRad.kneeToAnkleL,'y',210),
        globalCompositeOperation: 'source-over'
      }
    },
    legX:{
      left1:{
        key: 'legX-left1',
        type: 'pain',
        x: 1600,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth/2-90,
        offsetH: 366,
        translateX:0,
        //translateX: thighLeftTranslateX,
        translateY:0,
        //translateY: thighLeftTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:-translateX+2,
        descriptionY:460,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'weak',
        lineX:-translateX+2+180-2.5,
        lineY:462.5,
        moveX:backWidth/2+15,
        moveY:400,
        globalCompositeOperation: 'source-over',
      },
      left2:{
        key: 'legX-left2',
        type: 'pain',
        x: 2240,
        y: 400,
        width: 100,
        height: 200,
        offsetW: backWidth/2-30,
        offsetH: 435,
        translateX:0,
        //translateX: thighLeftTranslateX,
        translateY:0,
        //translateY: thighLeftTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:50+1,
        // descriptionY:550,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:50+180-10/4+1,
        // lineY:550+10/4,
        // moveX:backWidth/2-50+10+5+5+15+position(-backRad.hipToKneeR,'x',120),
        // moveY:100+380-110+100-30-5+position(-backRad.hipToKneeR,'y',60),
        globalCompositeOperation: 'source-over',
      },
      right1:{
        key: 'legX-right1',
        type: 'pain',
        x: 1880,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth/2-32,
        offsetH: 366,
        translateX:0,
        //translateX: thighRightTranslateX,
        translateY:0,
        //translateY: thighRightTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:backWidth-180+50-2,
        // descriptionY:460,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:backWidth-180+50+10/4-2,
        // lineY:460+10/4,
        // moveX:backWidth/2-50+10+5+5+15+30+60,
        // moveY:100+380-110-30+60,
        globalCompositeOperation: 'source-over',
      },
      right2:{
        key: 'legX-right2',
        type: 'pain',
        x: 2520,
        y: 400,
        width: 100,
        height: 200,
        offsetW: backWidth/2+85,
        offsetH: 435,
        translateX:0,
        //translateX: thighRightTranslateX,
        translateY:0,
        //translateY: thighRightTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:backWidth-180-translateX-2,
        descriptionY:550,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'weak',
        lineX:backWidth-180-translateX-2+2.5,
        lineY:552.5,
        moveX:backWidth/2+105+position(-backRad.hipToKneeL,'x',120),
        moveY:434+position(-backRad.hipToKneeL,'y',60),
        globalCompositeOperation: 'source-over',
      }
    },
    legO:{
      left1:{
        key: 'legO-left1',
        type: 'pain',
        x: 2800,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth/2,
        offsetH: 436,
        translateX:0,
        //translateX: thighLeftTranslateX,
        translateY:0,
        //translateY: thighLeftTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:-translateX+2,
        descriptionY:550,
        descriptionWidth:230,
        descriptionHeight:40,
        description:'tension',
        lineX:-translateX+2+230-2.5,
        lineY:552.5,
        moveX:backWidth/2+11+position(-backRad.hipToKneeR,'x',120),
        moveY:435+position(-backRad.hipToKneeR,'y',60),
        globalCompositeOperation: 'source-over',
      },
      left2:{
        key: 'legO-left2',
        type: 'pain',
        x: 3360,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth/2-38+position(-backRad.hipToKneeR,'x',180),
        offsetH: 374+position(-backRad.hipToKneeR,'y',180),
        translateX:0,
        //translateX: backWidth/2-15+position(-backRad.hipToKneeR,'x',180),
        translateY:0,
        //translateY: 376+position(-backRad.hipToKneeR,'y',180),
        rotate:0,
        //rotate: -backRad.kneeToAnkleR,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:50+1,
        // descriptionY:680,
        // descriptionWidth:200,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:50+200-10/4+1,
        // lineY:680+10/4,
        // moveX:backWidth/2-50-5+position(-backRad.hipToKneeR,'x',180)+5+20+position(-backRad.kneeToAnkleR,'x',50)+30+3,
        // moveY:156-70+200+50+position(-backRad.hipToKneeR,'y',180)+40+position(-backRad.kneeToAnkleR,'y',50),
        globalCompositeOperation: 'source-over'
      },
      right1:{
        key: 'legO-right1',
        type: 'pain',
        x: 3080,
        y: 400,
        width: 200,
        height: 200,
        offsetW: backWidth/2+75,
        offsetH: 436,
        translateX:0,
        //translateX: thighRightTranslateX,
        translateY:0,
        //translateY: thighRightTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        // descriptionX:backWidth-220-2+50,
        // descriptionY:550,
        // descriptionWidth:220,
        // descriptionHeight:40,
        // description:'tension',
        // lineX:backWidth-200-2+50+10/4,
        // lineY:550+10/4,
        // moveX:backWidth/2+30+60+position(-backRad.hipToKneeL,'x',120),
        // moveY:100+380-110+100-30-10+position(-backRad.hipToKneeL,'y',60),
        globalCompositeOperation: 'source-over',
      },
      right2:{
        key: 'legO-right2',
        type: 'pain',
        x: 3640,
        y: 400,
        width: 200,
        height: 200,
        offsetW:backWidth/2+77+position(-backRad.hipToKneeL,'x',180),
        offsetH:374+position(-backRad.hipToKneeL,'y',180),
        translateX:0,
        //translateX:backWidth/2+100+position(-backRad.hipToKneeL,'x',180),
        translateY:0,
        //translateY: 376+position(-backRad.hipToKneeL,'y',180),
        rotate:0,
        //rotate: -backRad.kneeToAnkleL,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:backWidth-210-translateX-2,
        descriptionY:680,
        descriptionWidth:210,
        descriptionHeight:40,
        description:'tension',
        lineX:backWidth-210-translateX-2+2.5,
        lineY:682.5,
        moveX:backWidth/2+92+position(-backRad.hipToKneeL,'x',180)+position(-backRad.kneeToAnkleL,'x',50),
        moveY:374+position(-backRad.hipToKneeL,'y',180)+position(-backRad.kneeToAnkleL,'y',50),
        globalCompositeOperation: 'source-over'
      }
    },
    legXO:{
      left1:{
        key: 'legXO-left1',
        type: 'pain',
        x: 3640,
        y: 0,
        width: 200,
        height: 200,
        offsetW: backWidth/2-30,
        offsetH: 431,
        translateX:0,
        //translateX: thighLeftTranslateX,
        translateY:0,
        //translateY: thighLeftTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeR,
        afterTranslate:false,
        //afterTranslate:true,
        // false,
        //// afterTranslate:true,
        // descriptionX:50+1,
        // descriptionY:550,
        // descriptionWidth:180,
        // descriptionHeight:40,
        // description:'weak',
        // lineX:50+180-10/4+1,
        // lineY:550+10/4,
        // moveX:backWidth/2-50+10+5+5+15+position(-backRad.hipToKneeR,'x',120),
        // moveY:100+380-110+100-30-5+position(-backRad.hipToKneeR,'y',60),
        globalCompositeOperation: 'source-over',
      },
      right1:{
        key: 'legXO-right1',
        type: 'pain',
        x: 3820,
        y: 0,
        width: 200,
        height: 200,
        offsetW: backWidth/2+27,
        offsetH: 435,
        translateX:0,
        //translateX: thighRightTranslateX,
        translateY:0,
        //translateY: thighRightTranslateY,
        rotate:0,
        //rotate: -backRad.hipToKneeL,
        afterTranslate:false,
        //afterTranslate:true,
        descriptionX:backWidth-180-translateX-2,
        descriptionY:550,
        descriptionWidth:180,
        descriptionHeight:40,
        description:'weak',
        lineX:backWidth-180-translateX-2+2.5,
        lineY:552.5,
        moveX:backWidth/2+105+position(-backRad.hipToKneeL,'x',120),
        moveY:430+position(-backRad.hipToKneeL,'y',60),
        globalCompositeOperation: 'source-over',
      },
    }
  }
  let backOrder = [
    'head',
    'body',
    'upperArm-left',
    'foreArm-left',
    'upperArm-right',
    'foreArm-right',
    'shank-left',
    'thigh-left',
    'shank-right',
    'thigh-right',
    'spine-left1',
    'spine-left2',
    'spine-right1',
    'spine-right2',
    'shoulder-left1',
    'shoulder-left2',
    'shoulder-left2',
    'shoulder-right1',
    'shoulder-right2',
    'round-left',
    'round-right',
    'fore-left',
    'fore-right',
    'rake-left1',
    'rake-left2',
    'rake-right1',
    'rake-right2',
    'legStretch-left1',
    'legStretch-right1',
    'legStretch-left2',
    'legStretch-right2',
    'legXO-left1',
    'legXO-right1',
    'legX-left1',
    'legX-left2',
    'legX-right1',
    'legX-right2',
    'legO-left1',
    'legO-left2',
    'legO-right1',
    'legO-right2',
  ]
  let backPain = getPainArr('back', data.conclusion,pains);
  //////console.log('backPain->',backPain);
  let backOrderInfos = getOrderInfos(backLocationInfo, backOrder);

  let backImg = new Image();
  backImg.src = imgSrc.bone.backBone;

  backImg.onload = function() {
    //console.log("img w:",backImg.width," img H:",backImg.height,'backWidth:',backWidth)
  /*   backBodyPostion.sx = 0;
    backBodyPostion.sy = 0;
    backBodyPostion.x = 0 + backWidth/20; */
    let ctx = backCanvas.getContext('2d');
    drawBone('back',ctx,backOrderInfos,backPain,backImg,translateX,(windowHeight-89)*220/backHeight,backBodyPostion,backWidth)
  }
}
//绘制骨骼筋膜图
function drawBone(direction,ctx,orderInfos,pain,img,translateX,translateY,BodyPostion,backWidth) {
  let bodyImg = new Image();

  bodyImg.src = BodyPostion.imgUrl;
  bodyImg.onload = function () {
    if(direction=='test'){
      ctx.drawImage(
        bodyImg,
        BodyPostion.sx,
        BodyPostion.sy,
        BodyPostion.swidth,
        BodyPostion.sheight,
        BodyPostion.x,
        BodyPostion.y,
        BodyPostion.width,
        BodyPostion.height
      );
    }
  }
  //console.log("direction,ctx,orderInfos,",BodyPostion)
  ctx.globalCompositeOperation = 'destination-over'
  ctx.save();


  ctx.translate(translateX,translateY);
  for (let i = 0; i < orderInfos.length; i++) {

    if (orderInfos[i] && (orderInfos[i].type !== 'pain' || (orderInfos[i].type === 'pain' && pain.indexOf(orderInfos[i].key) !== -1))) {
      ctx.save();
      //ctx.translate(orderInfos[i].translateX, orderInfos[i].translateY);
      //ctx.rotate(orderInfos[i].rotate);
      /* if(orderInfos[i].afterTranslate){
        ctx.translate(-orderInfos[i].translateX, -orderInfos[i].translateY);
      }
      if(orderInfos[i].rotateBefore) {
        ctx.restore();
        ctx.save();
        ctx.translate(orderInfos[i].translateXBefore, orderInfos[i].translateYBefore);
        ctx.rotate(orderInfos[i].rotateBeforeRad);
        ctx.translate(-orderInfos[i].translateXBefore, -orderInfos[i].translateYBefore);
      } */
      if (orderInfos[i].globalCompositeOperation) {
        ctx.globalCompositeOperation = orderInfos[i].globalCompositeOperation;
      }

      ctx.drawImage(img, orderInfos[i].x, orderInfos[i].y, orderInfos[i].width,
        orderInfos[i].height, orderInfos[i].offsetW, orderInfos[i].offsetH, orderInfos[i].width, orderInfos[i].height);

      ctx.restore();

      // ctx.globalCompositeOperation = 'source-over'
      // ctx.beginPath();
      // ctx.arc(orderInfos[i].translateXBefore,orderInfos[i].translateYBefore,4,0,360,false);
      // ctx.fillStyle='red';
      // ctx.fill();
      // ctx.closePath();

      // if(direction === 'face'){
      //  drawFaceTest(ctx,attr)
      // }

      if(orderInfos[i].description){
        let value = null;
        switch (direction){
          case 'face': value = drawFacePainDes(ctx,orderInfos[i]);
            ////console.log("desc value:",value,orderInfos[i].description)
            isNormal('faceNormal',value)
            break;
          case 'side': value =drawSidePainDes(ctx,orderInfos[i]);
            ////console.log("desc side:",value,orderInfos[i].description)
            isNormal('sideNormal',value)
            break;
          case'back': value = drawbackPainDes(ctx,orderInfos[i]);
            ////console.log("desc value back:",value,orderInfos[i].description)
            isNormal('backNormal',value)
            break;
          default:
            break;
        }
        console.log('descripName',init_t.descripName);
        drawDescription(ctx,10,orderInfos[i].descriptionX,orderInfos[i].descriptionY,
          orderInfos[i].descriptionWidth,orderInfos[i].descriptionHeight,
          orderInfos[i].moveX,orderInfos[i].moveY,descripName(orderInfos[i].description).color,
          value,orderInfos[i].lineX,orderInfos[i].lineY,direction);
      }
      ctx.globalCompositeOperation = 'destination-over'
    } else {
      continue;
    }
  }
}
function isNormal(bonePart,value){
  value != null ? bodyPart[bonePart] = false : null ;
}
function drawFacePainDes(ctx,faceOrderInfo) {
  let key = faceOrderInfo.key.split('-');
  let painName = key[0],lOrR = key[1];
  let boneDes = init_t.boneDescription['face'];
  console.log('boneDescription',init_t);
  let des,value ;
  if(key.length > 1){
    if(painName === 'legForX'){
      if(lOrR.indexOf('1')>-1){
        des = boneDes[painName][0]
      }else if(lOrR.indexOf('2')>-1){
        des =boneDes[painName][1]
      }
    }else{
      des = boneDes[painName]
    }
  }else{
    des = boneDes[key]
  }
  value = des+descripName(faceOrderInfo.description).name;
  return value;
}

function drawSidePainDes(ctx,sideOrderInfo) {
  let key = sideOrderInfo.key.split('-');
  let painName = key[0];
  let boneDes = init_t.boneDescription['side'];
  let des,value;
  if(key.length > 1){
    des =boneDes[painName]
  }else{
    des = boneDes[key]
  }
  value = des+descripName(sideOrderInfo.description).name;
  return value;
}

function drawbackPainDes(ctx,backOrderInfo) {
  let key = backOrderInfo.key.split('-');
  let painName = key[0],lOrR = key[1];
  let backDes =  init_t.boneDescription['back'];
  let des,value ;
  if(key.length > 1){
    if(painName === 'round' || painName === 'fore'){
      if(lOrR ==='left'){
        des =backDes[painName][1]
      }else if(lOrR==='right'){
        des = backDes[painName][0]
      }
    }
    else if(painName.indexOf('leg')>-1){
      if(lOrR.indexOf('1')>-1){
        des = backDes[painName][0]
      }else if(lOrR.indexOf('2')>-1){
        des = backDes[painName][1]
      }
    }
    else{
      des = backDes[painName]
    }
  }else{
    des = backDes[key]
  }
  value = des+descripName(backOrderInfo.description).name;
  return value;
}

function drawDescription(ctx,r,x,y,width,height,moveX,moveY,color,value,lineX,lineY,dir) {
  //// //console.log("(x+r,y:",x+r,y,"width-r+x,y:",width-r+x,y)
  //////console.log("width-r+x:",width-r+x)
  var len = 11;
  var fontSize = 23
  var oldWidth = width;
  if (value.length > len) {
    var count = Math.ceil(value.length / len)
    width = oldWidth
    height = count * fontSize+20
  }
  ctx.globalCompositeOperation = 'source-over'
  ctx.beginPath();
  ctx.arc(moveX,moveY,4,0,360,false);
  ctx.fillStyle="#808080";
  ctx.fill();
  ctx.closePath();

  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(x+r,y);
  ctx.lineTo(width-r+x,y);
  ctx.arc(width-r+x,r+y,r,Math.PI*3/2,0);
  ctx.lineTo(width+x,height-r+y);

  ctx.arc(width-r+x,height-r+y,r,0,Math.PI/2);
  ctx.lineTo(r+x,height+y);

  ctx.arc(r+x,height-r+y,r,Math.PI/2,Math.PI);
  ctx.lineTo(x,r+y);
  ctx.arc(r+x,r+y,r,Math.PI,Math.PI*3/2);

  console.log("lineX,lineY",lineX,lineY,' moveX,moveY',moveX,moveY)
  if (value.length > len) {
    var count = Math.ceil(value.length / len)
    width = width
    height = count * fontSize+20
  }
  ctx.moveTo(lineX,lineY);
  ctx.lineTo(moveX,moveY);
  ctx.strokeStyle = color;
  ctx.stroke();
  ctx.fillStyle = 'rgba(255,255,255,0.6)';
  ctx.fill();
  ctx.closePath();

  //  canvas文字换行
  var wrapText = function (text) {
    var text = text,
        fontSize = 23,
        lines = [],
        line = '',
        lineTest = '',
        words = text.split(' '),
        currentY = 0;

    ctx.font = fontSize + 'px Arial';

    for (var i = 0, len = words.length; i < len; i++) {
      lineTest = line + words[i] + ' ';

      // Check total width of line or last word
      if (ctx.measureText(lineTest).width > width) {
        // Calculate the new height
        currentY = lines.length * fontSize + fontSize;

        // Record and reset the current line
        lines.push({ text: line, height: currentY });
        line = words[i] + ' ';
      } else {
        line = lineTest;
      }
    }


    // Catch last line in-case something is left over
    if (line.length > 0) {
      currentY = lines.length * fontSize + fontSize;
      lines.push({ text: line.trim(), height: currentY });
    }

    // Visually output text
    // ctx.clearRect(0, 0, 500, 500);
    for (var i = 0, len = lines.length; i < len; i++) {
      ctx.fillStyle = color
      ctx.fillText(lines[i].text, width / 10 + x - 10, y + 40 + (i - 1) * fontSize + 24);
    }
  }

  wrapText(value)

  // if (value.length > len) {
  //   if (dir != 'face'){
  //     len= len + 4
  //   }
  //   var count = Math.ceil(value.length / len)
  //   for (var i = 1; i <= count; i++) {
  //       ctx.font = '23px PingFang SC'
  //       ctx.fillStyle = color
  //       ctx.textAlign = 'left'
  //       var riskStr = value.substring((i-1)*len, (i-1)*len+len)
  //     // var riskStr = value.substring((i-1)*len, (i-1)*len+len).replace(/(^\s*)|(\s*$)/g, "")

  //       ctx.fillText(riskStr, width/10+x-5,y+20+(i-1)*fontSize+10);
  //   }



  // }else{
  //   ctx.font = "23px PingFang SC";
  //   ctx.fillStyle = color;
  //   ctx.textAlign = 'center';
  //   ctx.fillText(value, width/2+x+2, height-11+y);
  // }

}
//计算部位角度
function getRad(topOrRightPoint, bottomOrLeftPoint, isHorizontal) {
  // 此时的 right 是指看人体正面时人体的右，即我们的左；
  // 此时的 left 是指看人体正面时人体的左，即我们的右；

  let _x = Math.abs(topOrRightPoint.x - bottomOrLeftPoint.x);
  let _y = Math.abs(topOrRightPoint.y - bottomOrLeftPoint.y);
  let radian;

  if (isHorizontal) {
    if (topOrRightPoint.y < bottomOrLeftPoint.y) {
      radian = Math.atan(_y / _x);
    } else if (topOrRightPoint.y > bottomOrLeftPoint.y) {
      radian = -Math.atan(_y / _x);
    } else {
      radian = 0;
    }
  } else {
    if (topOrRightPoint.y < bottomOrLeftPoint.y) {
      // 两个点垂直位置正常情况
      if (topOrRightPoint.x > bottomOrLeftPoint.x) {
        radian = Math.atan(_x / _y);
      } else if (topOrRightPoint.x < bottomOrLeftPoint.x) {
        radian = -Math.atan(_x / _y);
      } else {
        radian = 0
      }
    } else {
      // 两个点位置垂直不正常情况
      if((bottomOrLeftPoint.x === 0 && bottomOrLeftPoint.y === 0) || (topOrRightPoint.x === 0 && topOrRightPoint.y === 0)){
        radian = 0;
      }else{
        if (topOrRightPoint.x > bottomOrLeftPoint.x) {
          radian = Math.atan(_y / _x) + Math.PI / 2;
        } else if (topOrRightPoint.x < bottomOrLeftPoint.x) {
          radian = 3 * Math.PI / 2 - Math.atan(_y / _x);
        } else {
          radian = Math.PI;
        }
      }
    }
  }

  return 0;
}

function getOrderInfos(locationInfo, order) {
  let orderInfos = [];
  for (let i = 0; i < order.length; i++) {
    let pathArr = order[i].split('-');
    let info;
    for (let j = 0; j < pathArr.length; j++) {
      if (j === 0) {
        info = locationInfo[pathArr[j]];
      } else {
        info = info[pathArr[j]];
      }
    }
    orderInfos.push(info);
  }
  return orderInfos;
}



function isHighLowOrRake(name) {
  switch (name) {
    case 'unevenshoulder':
      return 'HighLow';
    case 'roundedshoulder':
      return 'round';
    case 'forwardhead':
      return 'fore';
    case 'lateralhead':
      return 'rake';
    case 'scoliosis':
      return 'spain';
    default:
      return ''
  }
}

function getLeg(name) {
  switch (name) {
    case 'xleg':
      return 'X';
    case 'oleg':
      return 'O';
    case 'xoleg':
      return 'XO';
    case 'kneehyperextension':
      return 'Stretch';
    default:
      return false
  }
}



function getBodyDirection(direction,risks) {
  //////console.log('risks',risks)
  let risk,position='normal',lOrR='';
  switch (direction){
    case 'face':
      risk =_.maxBy(risks, function(o) { if((o.position==='pelvis' || (o.position==='shoulder' && isHighLowOrRake(o.key)==='HighLow')) && o.level === level.severe){ return o.value; } });
      if(!_.isEmpty(risk)){
        lOrR = getShoulderLeftOrRight(risk.direction);
        position = risk.position;
      }
      break;
    case 'side':
      risk =_.maxBy(risks, function(o) { if(isHighLowOrRake(o.key)==='round' && o.level === level.severe){ return o.value; } });
      if(!_.isEmpty(risk)){
        position = isHighLowOrRake(risk.key);
      }
      break;
    case 'back':
      risk =_.maxBy(risks, function(o) { if((isHighLowOrRake(o.key)==='rake'  || isHighLowOrRake(o.key)==='HighLow') && o.level === level.severe){ return o.value; } });
      if(!_.isEmpty(risk)){
        let highLowOrRake = isHighLowOrRake(risk.key);
        if( highLowOrRake === 'HighLow'){
          lOrR = getShoulderLeftOrRight(risk.direction);
        }
        position = highLowOrRake
      }
      break;
    default:
      break;
  }
  return {position,lOrR}
}

function position(rad,pos,height) {
  let getPosition;
  if(pos === 'x'){
    getPosition = Math.sin(Math.abs(rad))*height
    if(rad>0){
      getPosition = -getPosition;
    }
  }else if(pos === 'y'){
    getPosition = Math.cos(Math.abs(rad))*height
  }
  return getPosition
}

function getPainArr(direction, data, pains) {
  let risks = data.face.risks.concat(data.side.risks);
  console.log({
    risk:risks
  })
  let painsTemplate = pains[direction];
  let left = '-left',left1 = '-left1',left2 = '-left2',right1 = '-right1',right2 = '-right2',right = '-right';
  let painArr = []
  switch (direction){
    case 'face':
      let trunk = _.find(risks, function(o) { return o.level === level.severe && o.position === 'trunk'});
      if(!_.isEmpty(trunk)){
        painArr.push(painsTemplate[trunk.position][0]);
      }
      let round = _.find(risks, function(o) { return o.level === level.severe && isHighLowOrRake(o.key) === 'round'});
      if(!_.isEmpty(round)){
        let painsTem = painsTemplate[round.position][0];
        painArr.push(painsTem+left);
        painArr.push(painsTem+right);
      }
      let legForStretch = _.find(risks, function(o) { return o.level === level.severe && getLeg(o.key) === 'Stretch'});
      if(!_.isEmpty(legForStretch)){
        let painsTem = painsTemplate[legForStretch.position];
        painArr.push(painsTem[2]+left);
        painArr.push(painsTem[2]+right);
      }
      let legForXOrO =_.maxBy(risks, function(o) { if((getLeg(o.key) === 'X' || (getLeg(o.key) === 'O')) && o.level === level.severe){ return o.value; } });
      if(!_.isEmpty(legForXOrO)){
        if(getLeg(legForXOrO.key) === 'X'){
          let painsTem = painsTemplate[legForXOrO.position][0];
          painArr.push(painsTem+left1);
          painArr.push(painsTem+right1);
          painArr.push(painsTem+left2);
          painArr.push(painsTem+right2);
        }else{
          let painsTem = painsTemplate[legForXOrO.position][1];
          painArr.push(painsTem+left);
          painArr.push(painsTem+right);
        }
      }
      break;
    case 'side':
      let shoulderOrRakeOrRound =_.maxBy(risks, function(o) { if(( isHighLowOrRake(o.key) === 'fore' || isHighLowOrRake(o.key) === 'round') && o.level === level.severe){ return o.value; } });
      if(!_.isEmpty(shoulderOrRakeOrRound)){
        let painsTem = painsTemplate[shoulderOrRakeOrRound.position];
        if(isHighLowOrRake(shoulderOrRakeOrRound.key) === 'fore'){
          painArr.push(painsTem[0]);
        }else{
          painArr.push(painsTem[1]);
        }
      }
      let highOrLow = _.find(risks, function(o) { return o.level === level.severe && isHighLowOrRake(o.key) === 'HighLow'});
      if(!_.isEmpty(highOrLow)){
        painArr.push(painsTemplate[highOrLow.position][0]+'-'+getShoulderLeftOrRight(highOrLow.direction));
      }
      break;
    case 'back':
      let head =_.maxBy(risks, function(o) { if(( isHighLowOrRake(o.key) === 'round' || isHighLowOrRake(o.key) === 'HighLow' || isHighLowOrRake(o.key) === 'spain' || isHighLowOrRake(o.key) === 'fore') && o.level === level.severe){ return o.value; } });
      if(!_.isEmpty(head)){
        let painsTem = painsTemplate[head.position];
        let highLowOrRake = isHighLowOrRake(head.key);
        let lOrR = getShoulderLeftOrRight(head.direction);
        if(highLowOrRake === 'round' || highLowOrRake === 'fore'){
          painArr.push(painsTem[1]+left);
          painArr.push(painsTem[1]+right);
        }else if(highLowOrRake === 'HighLow' || highLowOrRake === 'spain'){
          painArr.push(painsTem[0]+`-${lOrR}1`);
          painArr.push(painsTem[0]+`-${lOrR}2`);
        }
      }
      let rake =_.find(risks, function(o) { return isHighLowOrRake(o.key) === 'rake' && o.level === level.severe });
      if(!_.isEmpty(rake)){
        let painsTem = painsTemplate[rake.position][0];
        let lOrR = getShoulderLeftOrRight(rake.direction);
        painArr.push(painsTem+`-${lOrR}1`);
        painArr.push(painsTem+`-${lOrR}2`);
      }
      let leg =_.maxBy(risks, function(o) { if(( getLeg(o.key) === 'O' || getLeg(o.key) === 'X' || getLeg(o.key) === 'XO' || getLeg(o.key) === 'Stretch') && o.level === level.severe){ return o.value; } });
      if(!_.isEmpty(leg)){
        let painsTem = painsTemplate[leg.position];
        let isLeg = getLeg(leg.key);
        let i,j;
        if(isLeg === 'X'){
          i=0;j=0;
        }else if(isLeg === 'O'){
          i=1;j=1;
        }else if(isLeg === 'Stretch'){
          i=2;j=2;
        }else if(isLeg === 'XO'){
          i=2;j=3;
        }
        painArr.push(painsTem[i]+left1);
        painArr.push(painsTem[i]+right1);
        painArr.push(painsTem[j]+left2);
        painArr.push(painsTem[j]+right2);
      }
      break;
    default:
      break;
  }
  return painArr;
}

module.exports = {
  init: init,
  drawFrontBone: drawFrontBone,
  drawSideBone: drawSideBone,
  drawBackBone: drawBackBone,
  bodyPart: bodyPart,
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/bone.js